// removed by extract-text-webpack-plugin
module.exports = {"buttonSection":"_3YpG4"};